import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNbbComponent } from './simple-icons-nbb.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNbbComponent ],
    exports:      [ SimpleIconsNbbComponent ],
    bootstrap:    []
})
export class SimpleIconsNbbModule {}
